import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "list",
  class: "t-brokerSearch__list"
}
const _hoisted_2 = { class: "u-container" }
const _hoisted_3 = { class: "u-row" }
const _hoisted_4 = { class: "u-col-12" }
const _hoisted_5 = {
  key: 0,
  class: "u-container"
}
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "o-brokerSearchList__grid u-margin-bottom-xxxl" }
const _hoisted_8 = { class: "t-brokerSearch__toggle" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = {
  key: 1,
  class: "t-brokerSearch__map"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_portal_target = _resolveComponent("portal-target")!
  const _component_o_broker_search_list = _resolveComponent("o-broker-search-list")!
  const _component_o_broker_area_card = _resolveComponent("o-broker-area-card")!
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_o_broker_search_map = _resolveComponent("o-broker-search-map")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["t-brokerSearch", { 't-brokerSearch--listView': _ctx.view === 'list' }])
  }, [
    ($data.isDesktop || _ctx.view === 'list')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_portal_target, { name: "searchFilters" })
              ])
            ])
          ]),
          _createVNode(_component_o_broker_search_list, {
            texts: $props.texts.searchList
          }, null, 8 /* PROPS */, ["texts"]),
          ($props.brokerAreaCards.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("h2", {
                  class: "a-heading2 u-margin-bottom-md",
                  textContent: _toDisplayString($props.texts.searchList.brokerAreaCardsHeadline)
                }, null, 8 /* PROPS */, _hoisted_6),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.brokerAreaCards, (broker, index) => {
                    return (_openBlock(), _createBlock(_component_o_broker_area_card, {
                      key: index,
                      broker: broker
                    }, null, 8 /* PROPS */, ["broker"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ], 512 /* NEED_PATCH */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        class: "m-button m-button--black t-brokerSearch__toggleButton",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleView()))
      }, [
        _createElementVNode("span", {
          class: "m-button__text",
          textContent: _toDisplayString($options.viewTogglerText)
        }, null, 8 /* PROPS */, _hoisted_9),
        (_ctx.view === 'list')
          ? (_openBlock(), _createBlock(_component_a_icon, {
              key: 0,
              class: "m-button__icon",
              name: "pin"
            }))
          : ($data.isDesktop)
            ? (_openBlock(), _createBlock(_component_a_icon, {
                key: 1,
                class: "m-button__icon",
                name: "close"
              }))
            : (_openBlock(), _createBlock(_component_a_icon, {
                key: 2,
                class: "m-button__icon",
                name: "tiles"
              }))
      ])
    ]),
    (_ctx.view === 'map')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_o_broker_search_map)
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}